import { render, staticRenderFns } from "./HilfeSystem.vue?vue&type=template&id=05d19f42&"
import script from "./HilfeSystem.vue?vue&type=script&lang=js&"
export * from "./HilfeSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports